import { Component, OnInit, ElementRef, ViewChild, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { EventService } from '../../shared/services/event.service';
import * as moment from 'moment';
import * as d3 from 'd3';
import { ServerService } from '../../shared/services/server.service';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})

export class LineChartComponent implements OnInit {

  @ViewChild('box', { static: false }) box: ElementRef;
  @Input() fullScreen: boolean = false;
  @Input() data: NChart;
  @Input() buildingID: number = 0;
  @Input() selectedStageNumber: number = 0;

  svgHeight: number = 0;
  svgWidth: number = 0;

  yArr = [100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0];
  yLength: number = 0;
  xLength: number = 0;

  facts: NFactByMonth[] = [];
  versions: NVersion[] = [];
  new_versions: NCompletionPercent[] = [];

  xDates: XAxis[] = [];
  forecastLinePoints: { x1: number, y1: number, x2: number, y2: number } = null;

  currentDate: string = '';
  factPlanLeadDays: number;
  factLengthOne: boolean = false;
  isLag: boolean;
  lastFact: NFactByMonth;
  lastVersion: NVersion;
  totalLag: number = 0;


  sumOfBackLogDays: number = 0;
  ots3: number = 0;

  forecastDate: string = '';
  versionsXPoints: { x1: number, x2: number }[] = [];
  factPath: any;
  // factPath2: any;

  lastMaxDate: string = '';
  prevlastMaxDate: string = '';
  points = [];
  // points2 = [];

  factsFlag: boolean = false;
  versionsFlag: boolean = false;

  tableOpen: boolean = false;
  buildingLevelStages: BuildingLevelStage[] = [];

  constructor(private eventService: EventService, private cdr: ChangeDetectorRef,
              private serverService: ServerService) { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.fullScreen.previousValue === true) this.loadData();
  }

  ngAfterViewInit(): void {
    this.loadData();
  }

  loadData(): void {
    let width: number = 0;
    let height: number = 0;
    if (this.box && typeof this.box.nativeElement !== 'undefined') {
      width = this.box.nativeElement.offsetWidth;
      height = this.box.nativeElement.offsetHeight;
      this.svgWidth = width - 30;
      this.svgHeight = 91 * height / 100;
      this.drawGraphic();
      this.cdr.detectChanges();
    }
    if(typeof(this.buildingID) !== 'undefined'){
      this.serverService.getBuildingLevelStages(this.buildingID, null).then(res => {
        if(typeof(this.selectedStageNumber) !== 'undefined' && this.selectedStageNumber !== null) {
          this.buildingLevelStages = res;
          this.sortLevelStagesByStageNumber();
        }
      });
    }
  }

  sortLevelStagesByStageNumber() {
    this.buildingLevelStages = this.buildingLevelStages.filter(x => x.rowNum.charAt(0) === ''+this.selectedStageNumber);
  }

  drawGraphic(): void {
    if (this.data.facts.length > 0 || this.data.versions.length > 0) {
      this.yLength = 100 / this.yArr.length;
      // находим максимальную и минимальную дату чтобы нарисовать график по оси Х
      let minMaxDates = this.getMinMaxDates(this.data);
      this.xDates = this.getDates(minMaxDates.minDate, minMaxDates.maxDate);

      this.xLength = this.svgWidth / this.xDates.length;
      // план - белая линия
      this.getVersions();
      // факты - желтая линия
      this.getFacts();
    }
  }

  diffDayOfVersion: number = 0;
  getVersions(): void {
    if (this.data.versions.length > 0) {
      this.versionsFlag = true;
      this.versions = this.data.versions;
      this.versions.map(version => {
        this.versionsXPoints.push(
          {
            x1: this.getPointsVersions2(version.planStartDate) + this.xLength / 2,
            x2: this.getPointsVersions2(version.planEndDate) + this.xLength / 2
          });
      });
      this.lastVersion = this.versions.find(v => v.isLastVersion === true);
      this.diffDayOfVersion = this.getDayBetweenTwoDates(this.lastVersion.planStartDate, this.lastVersion.planEndDate);
    }
    // if (this.data.completionPercent.length > 0) {
    //   this.versionsFlag = true;
    //   this.new_versions = this.data.completionPercent;
    //   this.factPath2 = this.getLinePath2();
    // }
  }

  getFacts(): void {
    if (this.data.facts.length > 0) {
      this.factsFlag = true;
      this.facts = this.data.facts;
      this.factPath = this.getLinePath();

      if (this.facts.length === 1) this.factLengthOne = true;
      this.lastFact = this.facts[this.facts.length - 1];
      this.totalLag = this.data.forecastDateTotalLagAndPercent.totalLag;


      if (this.data.forecastDateTotalLagAndPercent.totalPercent < 100) {
        this.isLag = true;
        this.currentDate = moment(new Date()).format('YYYY-MM-DD');
        this.sumOfBackLogDays = this.getDifferenceTwoDate(this.currentDate, this.lastVersion.planEndDate);
        let forecastX2Point;
        let forecastPercent: number = 0;

        if (new Date(this.lastMaxDate).getFullYear() - new Date(this.prevlastMaxDate).getFullYear() > 2) {
          let monthPrevMaxDate = new Date(this.prevlastMaxDate);
          forecastX2Point = new Date(monthPrevMaxDate.getFullYear(), monthPrevMaxDate.getMonth() + 1, 28);
          forecastPercent = 70;
        } else {
          forecastX2Point = this.lastMaxDate;
          forecastPercent = 100;
        }
        this.forecastLinePoints = {
          x1: this.getPointsVersions2(this.lastFact.factDate) + this.xLength / 2,
          y1: this.getYByValue(this.lastFact.completionPercent),
          x2: this.getPointsVersions2(forecastX2Point) + this.xLength / 2,
          y2: this.getYByValue(forecastPercent)
        };

      } else if (this.data.forecastDateTotalLagAndPercent.totalPercent == 100) {
        this.isLag = false;
        // if (this.data.forecastDate) {
        //   this.factPlanLeadDays = this.getDifferenceTwoDate(this.lastVersion.planEndDate, this.data.forecastDate);
        // }
      }
      this.ots3 = this.fullScreen ? (this.svgWidth - 700) : (this.svgWidth - 400);
      // if (this.data.forecastDate) {
      //   this.forecastDate = this.getDate(this.data.forecastDate);
      // }
    }
  }

  getDate(date: string, dayIsTrue?: boolean): string {
    let dateEx = new Date(date);
    let day = dateEx.getDate();
    let monthEx = dateEx.getMonth() + 1;
    let year = dateEx.getFullYear();
    let month = this.eventService.getMonthName(monthEx, true);
    if (dayIsTrue) {
      return month + ' ' + year + 'г.';
    }
    return day + ' ' + month + ' ' + year + 'г.';
  }

  getDifferenceTwoDate(firstDate, secondDate): number {
    return moment(firstDate).diff(moment(secondDate), "days");
  }

  // линия для версии
  // getLinePath2(): string {
  //   this.points2 = this.getLinePoints2();
  //   let lineFunction = d3.line<Point>().x(d => {
  //     return d.x
  //   }).y(d => {
  //     return d.y;
  //   });
  //   return lineFunction(this.points2);
  // }

  // getLinePoints2() {
  //   return this.new_versions.map((val, i) => {
  //     return {
  //       x: this.getPointsVersions2(val.planDate),
  //       y: this.getYByValue(val.completionPercent)
  //     };
  //   });
  // }

  // линия для факта
  getLinePath(): string {
    this.points = this.getLinePoints();
    let lineFunction = d3.line<Point>().x(d => {
      return d.x
    }).y(d => {
      return d.y;
    });
    return lineFunction(this.points);
  }

  getLinePoints() {
    return this.facts.map((val, i) => {
      let planDateEx = this.getPlanDate(val.completionPercent);
      let diff = null;
      if (planDateEx !== '') {
        diff = val.lag;
      }
      return {
        x: this.getPointsVersions2(val.factDate),
        y: this.getYByValue(val.completionPercent),
        date: val.factDate,
        value: val.completionPercent,
        planDate: planDateEx,
        difference: diff
      };
    });
  }

  getYByValue(value: number): number {
    return this.svgHeight - (this.svgHeight * value / 100);
  }

  divisionNumber: number = 1;
  getDates(startDate, stopDate): XAxis[] {
    let dateArray: XAxis[] = [];
    let currentDate = new Date(startDate);
    let secondDate = new Date(stopDate);
    let count = 0;
    while (moment(currentDate).format('YYYY-MM') <= moment(secondDate).format('YYYY-MM')) {
      if (moment(currentDate).format('YYYY-MM') == moment(secondDate).format('YYYY-MM')) {
        dateArray.push({ date: moment(secondDate).format('YYYY-MM-DD'), position: 'last' });
      } else {
        let positionTitle: any;
        if (count === 0) {
          positionTitle = 'first';
        } else if (count === 1) {
          positionTitle = 'second';
        } else {
          positionTitle = count;
        }
        dateArray.push({ date: moment(currentDate).format('YYYY-MM-DD'), position: positionTitle });
      }
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
      count++;
    }

    length = count;

    if(length >= 12){
      this.divisionNumber = Math.ceil((length / 12));
      if(length % 12 > 4){
        this.divisionNumber += 1;
      }
      if(length > 30){
        this.divisionNumber += Math.round(length / 24);
      }
    }else{
      this.divisionNumber = 1;
    }

    if (dateArray.length > 3) {
      for(let i=2; i<=this.divisionNumber; i++){
        dateArray[dateArray.length - i].position = 'prevLast';
      }
    }

    dateArray.map(row => {
      if (typeof row.position === 'string' && row.position !== 'prevLast' && row.position !== 'second') {
        row.transformDate = this.getDate(row.date, true);
      }
      if (typeof row.position === 'number' && (row.position % this.divisionNumber === 0)) {
        row.transformDate = this.getDate(row.date, true);
      }
    });

    return dateArray;
  }

  getMinMaxDates(rows: NChart) {
    let arr = [];
    if (rows.versions.length > 0) {
      rows.versions.forEach(r => {
        if (arr.indexOf(new Date(r.planStartDate)) == -1) arr.push(new Date(r.planStartDate));
        if (arr.indexOf(new Date(r.planEndDate)) == -1) arr.push(new Date(r.planEndDate));
      });
    }

    if (rows.facts.length > 0) {
      if (arr.indexOf(new Date(rows.facts[0].factDate)) == -1) arr.push(new Date(rows.facts[0].factDate));
      if (arr.indexOf(new Date(rows.facts[rows.facts.length - 1].factDate)) == -1) arr.push(new Date(rows.facts[rows.facts.length - 1].factDate));
    }

    if (rows.forecastDateTotalLagAndPercent.forecastDate) {
      if (arr.indexOf(new Date(rows.forecastDateTotalLagAndPercent.forecastDate)) == -1) arr.push(new Date(rows.forecastDateTotalLagAndPercent.forecastDate));
    }

    function sortDates(a, b) {
      return a.getTime() - b.getTime();
    }
    let sortedArr = arr.sort(sortDates);

    let minVal = sortedArr[0];
    this.lastMaxDate = sortedArr[sortedArr.length - 1];
    this.prevlastMaxDate = sortedArr[sortedArr.length - 2];
    let maxEx;

    if (new Date(this.lastMaxDate).getFullYear() - new Date(this.prevlastMaxDate).getFullYear() > 2) {
      maxEx = this.prevlastMaxDate;
    } else {
      maxEx = this.lastMaxDate;
    }

    let maxExMonth = new Date(maxEx).getMonth() + 1;
    let maxVal = new Date(new Date(maxEx).getFullYear(), maxExMonth, 1);

    return { minDate: moment(minVal).format('YYYY-MM-DD'), maxDate: moment(maxVal).format('YYYY-MM-DD') };
  }

  getPointsVersions2(date: string): number {
    let ind = this.xDates.findIndex(r => (moment(r.date).format('YYYY-MM') === moment(date).format('YYYY-MM')));
    let day = new Date(date).getDate();
    let count = moment(moment(date).format('YYYY-MM'), "YYYY-MM").daysInMonth();
    let littleXlength = this.xLength / count;
    return ind * this.xLength + day * littleXlength;
  }

  transformDate(value: string, position: any): string {
    if (typeof position === 'string') {
      return moment(value).format('YYYY-MM-DD');
    }
    if (typeof position === 'number') {
      if (position % 6 === 0) {
        return moment(value).format('YYYY-MM-DD');
      }
    }
  }

  xPos: number = 0;
  yPos: number = 0;
  getRectPosition(x: number, y: number): string {
    this.xPos = this.fullScreen ? -10 : 10;
    this.yPos = this.fullScreen ? 15 : 5;

    if (this.svgHeight - y <= 60 && this.svgWidth - x > 400) {
      this.yPos = -60;
    }
    if (this.svgHeight - y > 60 && this.svgWidth - x <= 400) {
      this.xPos = -200;
      this.yPos = 15;
      if(this.fullScreen){
        this.xPos = -300;
      }
    }
    if (this.svgWidth - x <= 400 && this.svgHeight - y <= 60) {
      if (this.fullScreen) {
        this.xPos = -260;
        this.yPos = -180;
      } else {
        this.xPos = -120;
        this.yPos = -100;
      }
    }
    return `translate(${this.xPos}, ${this.yPos})`;
  }

  getPlanDate(percent: number) {
    let x = Math.floor(this.diffDayOfVersion * percent / 100);
    if(this.lastVersion) {
      let planDate = moment(this.lastVersion.planStartDate, "YYYY-MM-DD").add(x, 'days');
      return moment(planDate).format('YYYY-MM-DD');
    }else {
      return '';
    }
  }

  getDayBetweenTwoDates(firstDate, secondDate): number {
    let f = moment(firstDate);
    let s = moment(secondDate);
    return Math.abs(f.diff(s, 'days')) + 1;
  }

  getBuildingLevelStagesInfo() {
    if(typeof(this.selectedStageNumber) !== 'undefined' && this.selectedStageNumber !== null){
      this.tableOpen = true;
    }
  }

  closeTableView() {
    this.tableOpen = false;
  }

}

interface NFactByMonth {
  completionPercent?: number;
  factDate?: string;
  lag: number;
  month?: any;
  percent?: number;
  flag?: string;
}

interface Point {
  x: number;
  y: number;
}

interface XAxis {
  date: any;
  value?: number;
  flag?: string;
  click?: boolean;
  position?: any;
  transformDate?: string;
}

interface NChart {
  versions: NVersion[];
  facts: NFact[];
  // forecastDate: string;
  forecastDateTotalLagAndPercent: {
    forecastDate: string;
    totalLag: number;
    totalPercent: number;
  };
  completionPercent: NCompletionPercent[];
}

interface NCompletionPercent {
  completionPercent: number;
  planDate: string;
}

interface NVersion {
  versionId: number;
  planStartDate: string;
  planEndDate: string;
  isLastVersion: boolean;
}

interface NFact {
  factDate: string;
  completionPercent: number;
  lag: number;

}

interface BuildingLevelStage {
  categories: any[];
  completionPercent: number;
  factValue: number;
  floorID: number;
  id: number;
  isReadyFlag: boolean;
  lvl: number;
  lvlTitle: string;
  parentID: number;
  planFromDate: Date;
  planToDate: Date;
  planValue: number;
  prodIndicatorTitle: string;
  rowNum: string;
  stageIsReady: boolean;
  stragePath: string;
  title: string;
  unitID: number;
  unitTitle: string;
}
